import moment from 'moment';
import {AuthUser} from '../../types/models/AuthUser';
import {AuthType, APIBaseUrl} from './AppEnums';

export const authRole = {
  admin: ['admin'],
  user: ['user', 'admin'],
};

export const defaultUser: AuthUser = {
  uid: 'RFedvhji876rfhjuecvh7',
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: authRole.user,
  authType: AuthType.AUTH0,
  photoURL: 'https://via.placeholder.com/150',
};
export const menuUrl = '/dashboards/e-commerce'; // this url will open after login
export const initialUrl = '/home'; 
export const invalidUrl = '/error-pages/invalidLink'; // this url initial '/error-pages/invalidLink'
//export const homeUrl = () => { return '/home?outletState='+localStorage.getItem('GSC_locstate')+'&outletCode='+localStorage.getItem('GSC_locid'); }// this url initial
export const homeUrl = () => { return '/home' }// this url initial
export const userinfoUrl = () => { return '/home?outletRegion='+localStorage.getItem(phase+'_GSC_locregion')+'&outletCode='+localStorage.getItem(phase+'_GSC_locid'); }// this url initial

const setAPIBaseUrl = (env: string) => {
  if(env === 'DEV')
    return APIBaseUrl.DEV; 
  else if(env === 'PROD')
    return APIBaseUrl.PROD; 
}

export const apiBaseUrl:APIBaseUrl | undefined = setAPIBaseUrl('PROD');  //DEV,UAT,PROD
export const CSOMTUrl = setAPIBaseUrl('PROD')+'/CSOMT'; //URL for CSO Maintenance Screen
export const maxOrder= 10; //Max products per transaction
export const maxItems= 10; //Max items per product
//export const maxDaysPreOrder = 1; //Control max days for preorder 
export const timeToGetOrderStatus = 8; //minutes to get order status
export const charShowMore= 30; //More than max char will appear show more for user to click
export const timeToTriggerStatusAPI = 8; //8 seconds to trigger order status API

const operationDateTime = moment(new Date()).add(1, 'days').format("dddd, DD MMMM YYYY");
export const notificationMessage = 'Food and drinks purchased are valid for same-day redemption only.\nKindly redeem your purchase from the GSC concessions counter by ' 
+ operationDateTime + ', before 5.59am.';
export const version = '2.2';
export const phase = 'P2';

export const openTime = 8 * 60 + 0 ;//System Start Service Time
export const closeTime = 23 * 60 + 55 ;//System Stop Service Time